import React, { useState, useEffect } from 'react'
import useBroker from '@hooks/useBroker'

// 넷 다 같은 토픽('dashboard')으로 오고 구분은 service가 한다 -- 그래서 topic이 아니라
// service로 가르는 구조가 필요했다.
//
// idField가 없다 = 레코드를 안 쌓고 **장애 여부만 본다**는 선언이다. 수집기는 content를
// 안 싣고 error 칸만 채워 보낸다(RemoteMessage(exchangeId, service, error, "", "")).
//
// histo.collector도 같은 토픽으로 오지만 이 표에 없어서 자동으로 무시된다.
const SUBSCRIPTIONS = [
  { topic: 'dashboard', service: 'binance.supply' },
  { topic: 'dashboard', service: 'bitget.supply' },
  { topic: 'dashboard', service: 'binance.collector' },
  { topic: 'dashboard', service: 'bitget.collector' },
]

// 수집기 발행이 1초 주기다(dumpKline 루프). 이보다 한참 지났으면 그 서비스가 멈춘 것이다.
const STALE_MILLIS = 10000

// at은 메시지가 와야 바뀐다. 서비스가 죽으면 아무것도 안 오므로 상태 변화도 리렌더도 없어
// **화면이 '정상'인 채로 굳는다.** 시계를 돌려 주기적으로 다시 판정한다.
const TICK_MILLIS = 2000

const DashboardPage = () => {
  const { services, connected } = useBroker(SUBSCRIPTIONS)
  const [, set_tick] = useState(0)

  useEffect(() => {
    const timer = setInterval(() => set_tick(n => n + 1), TICK_MILLIS)
    return () => clearInterval(timer)
  }, [])

  const stateOf = (service) => {
    // 한 번도 못 받았다 -- 브로커는 붙었는데 그 서비스가 안 뜬 경우다.
    if (!service) {
      return { label: '수신 없음', bad: true }
    }
    if (service.error) {
      return { label: `장애: ${service.error}`, bad: true }
    }
    // error가 ''이면 정상이라는 뜻이지만, 그게 **언제** 온 정상인지는 at이 말한다.
    if (Date.now() - service.at > STALE_MILLIS) {
      return { label: '끊김', bad: true }
    }
    return { label: '정상', bad: false }
  }

  const renderService = (subscription) => {
    const name = subscription.service
    const state = stateOf(services[name])
    return (
      <div key={name}>
        <b>{name}</b>{' '}
        <span style={{ color: state.bad ? 'red' : 'green' }}>{state.label}</span>
      </div>
    )
  }

  // 최소 확인용 렌더 -- 배선이 살아있는지 보기 위한 것이지 최종 화면이 아니다.
  return (
    <>
      {!connected && <div>브로커 연결 끊김</div>}
      {SUBSCRIPTIONS.map(renderService)}
    </>
  )
}

export default DashboardPage
